import { render } from "./app-modal-add-product.vue?vue&type=template&id=5720b0ea"
import script from "./app-modal-add-product.vue?vue&type=script&lang=js"
export * from "./app-modal-add-product.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/item/app-modal-add-product.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5720b0ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5720b0ea', __exports__)) {
    console.log('reload')
    api.reload('5720b0ea', __exports__)
  }
  
  module.hot.accept("./app-modal-add-product.vue?vue&type=template&id=5720b0ea", () => {
    console.log('re-render')
    api.rerender('5720b0ea', render)
  })

}


export default __exports__